import {
  Component,
  EventEmitter,
  Output,
  forwardRef,
  OnInit,
  ElementRef,
  Input,
  Host,
  Optional
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  ValidationErrors
} from '@angular/forms';
import { NgxsOnInit } from '@ngxs/store';
import { AbstractField } from './abstract-field.component';

const customValueProvider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ZipFieldComponent),
  multi: true
};

@Component({
  selector: 'zip-field',
  inputs: [...AbstractField.inputs],
  outputs: [...AbstractField.outputs],
  template: `
    <div
      [floatingLabel]="model"
      [focus]="focused"
      [ngClass]="{
        'validation-failed':
          (showValidation || inp.dirty || inp.touched) &&
          required &&
          (!model || model == '' || !inp.valid)
      }"
    >
      <label for="FIELD={{ id }}">{{
        countrySettings.label + (required ? '*' : '')
      }}</label>
      <input
        [autocomplete]="autocomplete"
        [attr.name]="autocomplete"
        id="FIELD-{{ id }}"
        [(ngModel)]="model"
        [placeholder]="countrySettings.label + (required ? ' *' : '')"
        class="form-control"
        (focus)="focused = true"
        (blur)="onBlur($event)"
        (ngModelChange)="onChange($event)"
        [disabled]="disabled"
        [required]="required"
        [pattern]="countrySettings.pattern"
        #inp="ngModel"
        [attr.maxLength]="countrySettings.max"
        [attr.minLength]="countrySettings.min"
        type="text"
      />
    </div>
  `,
  providers: [customValueProvider]
})
export class ZipFieldComponent extends AbstractField {
  @Input() country;
  get countrySettings() {
    if (this.country && this.country == 'US') {
      return {
        min: 5,
        max: 10,
        pattern: '^\\d{5}(?:[-\\s]\\d{4})?$',
        label: 'Zip Code'
      };
    } else if (this.country && this.country == 'CA') {
      return {
        min: 6,
        max: 7,
        // canadian postal codes as laid out in wikipedia... https://en.wikipedia.org/wiki/Postal_codes_in_Canada
        pattern: new RegExp(
          '([ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ]) ?([0-9][ABCEGHJKLMNPRSTVWXYZ][0-9])',
          'i'
        ),
        label: 'Postal Code'
      };
    } else {
      return {
        min: 0,
        max: null,
        pattern: null,
        label: 'Postal Code'
      };
    }
  }
  constructor() {
    super();
  }
}
